export const isIncludeSubstring = (
  string,
  subString,
) => string.toLowerCase().includes(subString.toLowerCase());
